/**
 * @flow
 * @relayHash 80f253fe8c09055f2287eeedcd0dafc4
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type StatsLoaderQueryVariables = {||};
export type StatsLoaderQueryResponse = {|
  +viewer: ?{|
    +users: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +_id: ?string,
          +id: string,
          +email: ?string,
          +name: ?string,
          +canDelete: ?boolean,
          +blocked: ?boolean,
        |}
      |}>
    |}
  |}
|};
export type StatsLoaderQuery = {|
  variables: StatsLoaderQueryVariables,
  response: StatsLoaderQueryResponse,
|};
*/


/*
query StatsLoaderQuery {
  viewer {
    users(first: -1) {
      edges {
        node {
          _id
          id
          email
          name
          canDelete
          blocked
        }
      }
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "users",
  "storageKey": "users(first:-1)",
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": -1,
      "type": "Int"
    }
  ],
  "concreteType": "UserConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "UserEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "_id",
              "args": null,
              "storageKey": null
            },
            v0,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "email",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "name",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "canDelete",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "blocked",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "StatsLoaderQuery",
  "id": null,
  "text": "query StatsLoaderQuery {\n  viewer {\n    users(first: -1) {\n      edges {\n        node {\n          _id\n          id\n          email\n          name\n          canDelete\n          blocked\n        }\n      }\n    }\n    id\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "StatsLoaderQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          v1
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "StatsLoaderQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          v1,
          v0
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8b1251a356358f750a8e77fa81ae27c3';
module.exports = node;



// WEBPACK FOOTER //
// src/components/stats/__generated__/StatsLoaderQuery.graphql.js